import React, { Component } from 'react'
import RuleFilters from './RuleFilters'
import RuleActions from './RuleActions'

import './style'

class RulesEditorOverview extends Component {

  saveTitleChange = (event) => {
    this.props.updateTitle(event.target.value)
  }

  render() {
    const { rule, activeFilter, isActionOnlyField } = this.props
    const { conditions, action, id } = rule.data.item
    const noFilters = ((conditions.length === 0 || conditions[0].length === 0) && !!id) || isActionOnlyField(activeFilter.field)

    return (
      <div className="rules-editor-overview">
        <header>
          <input type="text"
            value={this.props.rule.data.item.name}
            onChange={ this.saveTitleChange }
            placeholder="Name your rule"
            id="title-input"
          />
        </header>

        {!noFilters && <RuleFilters
          conditions={conditions}
          setActivePage={this.props.setActivePage}
          activePage={this.props.activePage}
          activeFilter={this.props.activeFilter}
          setActiveFilter={this.props.setActiveFilter}
          currentPageIsValid={this.props.currentPageIsValid}
          saveActiveFilter={this.props.saveActiveFilter}
          removeFilter={this.props.removeFilter}
          isActionOnlyField={this.props.isActionOnlyField}
        />}
        <RuleActions action={action} setActivePage={this.props.setActivePage} users={this.props.users} activePage={this.props.activePage} noFilters={noFilters}/>

      </div>
    )
  }
}

export default RulesEditorOverview



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/RulesEditorOverview/index.js